import { addError, removeError } from '@core/utils/error-functions';
import moment from 'moment';
var DatePeriodValidation = /** @class */ (function () {
    function DatePeriodValidation() {
    }
    DatePeriodValidation.validate = function (fieldsToValidate) {
        return function (formGroup) {
            fieldsToValidate.forEach(function (field) {
                var fieldGte = formGroup.controls[field + "Gte"];
                var fieldLte = formGroup.controls[field + "Lte"];
                var fieldGteValue = fieldGte.value && moment(fieldGte.value);
                var fieldLteValue = fieldLte.value && moment(fieldLte.value);
                if (!fieldGteValue || !fieldLteValue) {
                    return null;
                }
                if (fieldGteValue.isAfter(fieldLteValue)) {
                    addError(fieldGte, 'invalidPeriod');
                    addError(fieldLte, 'invalidPeriod');
                }
                else {
                    removeError(fieldGte, 'invalidPeriod');
                    removeError(fieldLte, 'invalidPeriod');
                }
            });
            return null;
        };
    };
    return DatePeriodValidation;
}());
export { DatePeriodValidation };
